import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiTarget, FiTrendingUp, FiBarChart2, FiDollarSign } = FiIcons;

const FinalCTA = () => {
  const benefits = [
    { icon: FiZap, text: "Set up in 5 minutes" },
    { icon: FiTarget, text: "Schedule unlimited posts" },
    { icon: FiTrendingUp, text: "Run viral campaigns" },
    { icon: FiBarChart2, text: "Track everything" },
    { icon: FiDollarSign, text: "Starting at $19/month" }
  ];

  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-brand-teal to-brand-navy text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
      
      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h2 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight">
            Ready to Reclaim 10+ Hours Per Week?
          </h2>
          <p className="text-xl md:text-2xl mb-12 opacity-80 max-w-2xl mx-auto">
            Join 1,200+ entrepreneurs using Postifyr to automate their social media
          </p>
        </motion.div>

        {/* Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center items-center gap-6 md:gap-10 mb-16"
        >
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-center space-x-2">
              <SafeIcon icon={benefit.icon} className="text-white text-xl" />
              <span className="text-lg font-medium">{benefit.text}</span>
            </div>
          ))}
        </motion.div>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mb-8"
        >
          <a 
            href="https://dashboard.postifyr.com/rsa176125959b2e527cd97c7b79622c6fdb?ref=final-cta"
            className="inline-block bg-brand-yellow text-brand-navy text-xl font-bold px-12 py-5 rounded-xl hover:bg-white hover:scale-105 transition-all shadow-2xl"
          >
            Start My Free Trial →
          </a>
        </motion.div>

        {/* Secondary Link */}
        <motion.div
           initial={{ opacity: 0 }}
           whileInView={{ opacity: 1 }}
           viewport={{ once: true }}
           transition={{ delay: 0.6 }}
           className="mb-12"
        >
           <a href="#pricing" className="text-white underline hover:no-underline hover:text-brand-yellow transition-colors">View all pricing plans</a>
        </motion.div>

        {/* Trust Line */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-base opacity-70"
        >
          <p>No credit card • Cancel anytime • 30-day money-back guarantee</p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;